import { SUPPORTED_LANGUAGES } from "./config";
import type { AppLanguageType } from "./config";

export const getNextLanguage = (currentCode: AppLanguageType | string) => {
  const currentIndex = SUPPORTED_LANGUAGES.findIndex(({ code }) => code === currentCode);
  return SUPPORTED_LANGUAGES[(currentIndex + 1) % SUPPORTED_LANGUAGES.length];
};
